import React from 'react';
import PropTypes from 'prop-types';
import OptionsList from '../OptionsList';
import Spinner from '../../Spinner';

const ModalOptions = ({
                        options,
                        selectOption,
                        selected,
                        optionsListLabel
}) => (
  (options === null)
    ? <Spinner/>
    : (
      <OptionsList
        options={options}
        selectOption={selectOption}
        selected={selected}
        optionsListLabel={optionsListLabel}
      />
    )
);

ModalOptions.propTypes = {
  options: PropTypes.array,
  selectOption: PropTypes.func.isRequired,
  selected: PropTypes.object,
  optionsListLabel: PropTypes.node
};

export default ModalOptions;
